import { combineReducers } from 'redux';
import historianSearch from './search-historian';

export default combineReducers({ historianSearch });
